import React from 'react'
import { PageLayout } from 'app/views/components/layout/page-layout'
import { DealDrillPage } from './deal-drill-page'


export function DealLandingPage() {
    return (
        <PageLayout>
            <DealDrillPage />
        </PageLayout>
    )
}